module.exports = __webpack_public_path__ + "static/media/loginBank.3658c437.png";